import type { TableBlock as TableBlockType } from '../types/report'
import styles from './blocks.module.css'

export function TableBlock({ block }: { block: TableBlockType }) {
  return (
    <div className={styles.block}>
      {block.title ? <div className={styles.blockTitle}>{block.title}</div> : null}
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              {block.columns.map((col, i) => (
                <th key={i}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {block.rows.map((row, ri) => (
              <tr key={ri}>
                {row.map((cell, ci) => (
                  <td key={ci}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
